<template>
  <div class="featured-episode" v-if="podcast">
    <img v-if="podcast.image_url" :src="podcast.image_url" />
    <img v-else src="@/assets/img/podcast.png" />
    <div class="podcast-box">
      <div class="cs-textstyle-paragraph-small-bold">
        {{ podcast.created_at | moment('MMM DD, YYYY') }}
      </div>
      <div class="cs-textstyle-section-heading">
        {{ podcast.title }}
      </div>
      <div class="cs-textstyle-paragraph mt-3">
        <app-expandable-text
          read-white
          :content="podcast.description | text"
          placeholder="No description"
        />
      </div>
      <div class="button-class d-flex flex-row">
        <cs-button
          class="listen-button"
          @click.stop="onOpenPodcast(podcast.enclosure_url)"
          ><i class="cs-icons-play-filled mr-2"></i>Listen to this
          episode</cs-button
        >
        <div class="cs-textstyle-paragraph ml-3 mt-2">
          {{ time }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppExpandableText from '@/components/global/ExpandableText.vue';
export default {
  components: {
    AppExpandableText
  },
  props: {
    podcast: {
      type: Object,
      required: true
    }
  },
  computed: {
    time() {
      let sec = this.podcast.duration;
      let hours = Math.floor(sec / 3600);
      hours >= 1 ? (sec = sec - hours * 3600) : (hours = '00');
      let min = Math.floor(sec / 60);
      min >= 1 ? (sec = sec - min * 60) : (min = '00');

      min.toString().length == 1 ? (min = '0' + min) : void 0;
      if (hours > 0) {
        return hours + ' hr ' + min + ' mins';
      } else return min + ' mins ';
    }
  },
  methods: {
    onOpenPodcast(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
.podcast-box {
  border-radius: 10px;
  background: $primary;
  padding: 20px;
  margin: 1px 0px;
  color: var(--cs-gray-00);
  @include media-breakpoint-up(lg) {
    width: 100%;
    border-radius: 0px 10px 10px 0px;
    margin: auto 0px;
    background: $primary;
    color: var(--cs-gray-00);
    padding: 30px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
}
img {
  border-radius: 10px;
  height: 200px;
  width: 190px;
  @include media-breakpoint-up(md) {
    height: 387px;
    width: 373px;
  }
}
.button-class {
  margin-top: 20px;
}
.listen-button {
  --cs-button-color: var(--cs-gray-00) !important;
  --cs-button-text-color: var(--primary) !important;
}
.featured-episode {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  @include media-breakpoint-up(md) {
    flex-direction: row;
  }
}
@media (max-width: 768px) {
  .featured-episode img {
    height: 200px;
    width: 100%;
    object-fit: cover;
  }
}
</style>
